/** Created by azhou on 2019/3/26.*/
<template>
  <div>
    <public-title>景区门票审核</public-title>
    <div class="load-area">
      <el-tabs v-model="activeName" @tab-click="$GFUN.pageChange(1);getDataLists()">
        <el-tab-pane :name="item.id" v-for="item in tabArr" :key="item.id">
          <label slot="label">{{item.name}}
            <span class="unread-msg" v-if="waitVerify.ticket>0 && item.name==='未审核'">{{waitVerify.ticket}}</span>
          </label>
        </el-tab-pane>
      </el-tabs>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else>
        <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
          <li class="w-50 list-item-col">
            <span class="text-link" @click="goStoreDetail(item.store_id)">{{item.store_name}}</span>
          </li>
          <li class="w-50 list-item-col">{{item.name}}</li>
          <li class="w-50 list-item-col">{{item.ticket_type==1?'团队门票':'散客门票'}}</li>
          <li class="w-50 list-item-col">{{item.create_time | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col-end flex-wrap">
            <span class="text-link" @click="verifyItem(item)">{{activeName==='0'?'去审核':'查看'}}</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapActions,mapState } from 'vuex'

  export default {
    name: 'VerifyTicket',
    computed: {
      ...mapState(['AdminDataLists','waitVerify']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getDataLists(); },
    },
    data() {
      return {
        activeName:'0',
        titleArr:['景区名称','门票名称','门票类别','创建时间','操作'],
        tabArr:[{name:'未审核',id:'0'},{name:'已审核',id:'1'}]
      }
    },
    created() { this.getDataLists(); },
    methods:{
      ...mapActions(['getAdminDataLists']),
      getDataLists() {
        this.getAdminDataLists({
          type:'ticketList',
          data:{
            ...this.queryCon,
            is_verify: this.activeName,
          }
        });
      },
      //查看门店详情
      goStoreDetail(id) {
        this.$router.push({name:'StoreDetail',query:{type:6,id}})
      },
      //去审核
      verifyItem(item) {
        if (!this.$GFUN.powerIsInArray([425])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({
          name:'addEditTicket',
          query:{
            id:item.id
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .unread-msg{
    top: 5px;
    left: 48px;
  }
</style>
